module.exports = __webpack_public_path__ + "static/media/paper-plane-icon.b44a6484.svg";